export const NOTHING = '';

export default function formatBackToLineHtml(value) {
  if (!value) return '';
  return value.replace(/\n/g, '<br>');
}
